<template>
  <el-container>
    <!-- 主体内容 -->
    <el-header
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>负面舆情列表</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button-group> </el-button-group>
    </el-header>
    <el-main>
      <div>
        <!-- 查询工具栏-->
        <div class="mb-3 cust_seach">
          <el-input
            class="btnTitle"
            v-model="query.queryString"
            placeholder="请输入模糊字段"
          />
          <el-button-group>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="querySubmit"
            />
          </el-button-group>
        </div>
        <el-table :data="data.psts">
          <el-table-column prop="postingTime" label="发贴时间" width="100" align="center">
            <template slot-scope="scope">
              <div>
                {{ Common.dateFormatter(scope.row.postingTime, "yyyy-MM-dd") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="发贴人" width="100"  align="center"/>
          <el-table-column prop="pstType" label="舆情类型" width="100" align="center">
            <template slot-scope="scope">
              <span>{{ pstApi.getPstTypeName(scope.row.pstType) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="标题">
            <template slot-scope="scope">
              <div>
                <el-button
                  type="text"
                  size="small"
                  @click="detail(scope.row.id)"
                >
                  {{ scope.row.title }}
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="pstSource" label="舆情来源" width="120" align="center">
            <template slot-scope="scope">
              <div>
                <a :href="scope.row.pstUrl" target="_blank">{{
                  scope.row.pstSource
                }}</a>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="lastTime" label="上报时间" width="150" align="center">
            <template slot-scope="scope">
              <span>
                {{Common.dateFormatter(scope.row.lastTime,"yyyy-MM-dd hh:mm")}}
              </span>
            </template>
          </el-table-column> 
          <el-table-column prop="status" label="状态" width="80" align="center">
            <template slot-scope="scope">
              <el-tag
                :type="
                  scope.row.status === 6 || scope.row.status === -1
                    ? 'info'
                    : 'success'
                "
                disable-transitions
                >{{ pstApi.getStatusTransferTitle(scope.row.status) }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column prop="status" width="60" fixed="right" label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.status == -2"
                @click="negativeAudit(scope.row.id)"
                type="text"
                size="small"
              >
                审查
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="cust_pagin">
          <el-pagination
            layout="prev, pager, next"
            :total="xpagination.totalCount"
            :page-size="xpagination.pageSize"
            :current-page="xpagination.pageNumber"
            @current-change="handleCurrentChange"
            hide-on-single-page
            :background="true"
          />
        </div>
      </div>
    </el-main>
  </el-container>
</template>
    
  <script>
export default {
  created() {
    this.getPstList(); //读取分页信息
  },
  data() {
    return {
      //数据项
      data: {
        units: [], //单位数据
        psts: [], //舆情信息
      },
      //搜索栏数据
      query: {
        unitId: "00000000-0000-0000-0000-000000000000", //单位信息
        pstType: 1, //类别
        category: [-2], //状态
        queryString: "", //模糊字段
        isSubmit: 1,
      },
      //分页栏数据
      xpagination: {
        totalCount: 1,
        pageSize: 10,
        pageNumber: 1,
        totalPages: 1,
      },
      //上传对话框
      upload: {
        dialogFormVisible: false,
        dialogWidth: this.ISMOBILE ? "100%" : "500px",
        importFileList: [],
      },
    };
  },
  methods: {
    //查询方法部分
    querySubmit() {
      this.getPstList();
    },
    getUnits() {
      this.data.units = [
        {
          id: "00000000-0000-0000-0000-000000000000",
          name: "所有单位",
        },
      ];
      this.User.apiGetUnits().then((res) => {
        var data = res.data;
        this.data.units = this.data.units.concat(data);
      });
    },
    getPstList() {
      this.pstApi
        .getPstList(
          this.query.unitId,
          this.query.pstType,
          this.query.category,
          this.query.queryString,
          this.xpagination.pageNumber,
          this.xpagination.pageSize,
          this.query.isSubmit
        )
        .then((res) => {
          var data = res.data;
          this.data.psts = data;
          //console.log(data);
          var pagin = JSON.parse(res.headers.xpagination);
          this.xpagination.totalCount = parseInt(pagin.totalCount);
          this.xpagination.pageSize = parseInt(pagin.pageSize);
          this.xpagination.pageNumber = parseInt(pagin.currentPage);
          this.xpagination.totalPages = parseInt(pagin.totalPages);
        })
        .catch(() => {
          Toast("读取失败");
        });
    },
    //分页操作
    handleCurrentChange(val) {
      this.xpagination.pageNumber = val;
      this.getPstList();
    },
    negativeAudit(pstId) {
      this.$router.push({ name: "PstAudit", params: { id: pstId } });
    },
    detail(pstId) {
      this.$router.push({ name: "Details", params: { id: pstId } });
    },
  },
};
</script>
    
  <style lang="less" scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 40px;
}
//工具栏样式
.cust_seach {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  padding: auto 5px;
  .btnLeft {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }
  .btnTitle {
    flex: 2;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
  .btnStatus {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }
  .el-button-group > .el-button:first-child:last-child {
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
.el-select {
  float: left;
}
.cust_pagin {
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 999;
}
/deep/.el-breadcrumb__separator {
  color: rgb(87, 86, 86);
}
</style>